/**
 * Site logo. Links back to the main McQueens Dairies marketing site
 * rather than the portal's own root — once a customer's logged in,
 * the dashboard already lives at "/" so an internal logo link would
 * be a no-op. The expected "logo goes home" behaviour for customers
 * is "back to mcqueensdairies.co.uk".
 */
function Logo(): React.JSX.Element {
  return (
    <a href="https://www.mcqueensdairies.co.uk/" className="logo-link">
      <img
        src="/mcqueens-logo.png"
        alt="McQueens Logo"
        className="logo-image"
      />
    </a>
  )
}

export default Logo
